import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchBuilding_groups_groupIdBuildings = z.any()
export type TagsPatchBuilding_groups_groupIdBuildings = z.infer<typeof tagsPatchBuilding_groups_groupIdBuildings>

export const paramsPatchBuilding_groups_groupIdBuildings = z.object({ "groupId": z.string().uuid() })
export type ParamsPatchBuilding_groups_groupIdBuildings = z.infer<typeof paramsPatchBuilding_groups_groupIdBuildings>

export const bodyPatchBuilding_groups_groupIdBuildings = z.object({ "municipalityId": z.string().uuid(), "buildingIds": z.array(z.string().uuid()) })
export type BodyPatchBuilding_groups_groupIdBuildings = z.infer<typeof bodyPatchBuilding_groups_groupIdBuildings>

export const responsePatchBuilding_groups_groupIdBuildings = z.any()
export type ResponsePatchBuilding_groups_groupIdBuildings = z.infer<typeof responsePatchBuilding_groups_groupIdBuildings>

interface IPatchBuilding_groups_groupIdBuildings extends BaseMethodType {
  tags: TagsPatchBuilding_groups_groupIdBuildings,
  params: ParamsPatchBuilding_groups_groupIdBuildings,
  body: BodyPatchBuilding_groups_groupIdBuildings,
  response: ResponsePatchBuilding_groups_groupIdBuildings
}
export const URL = '/building-groups/:groupId/buildings'
export const validation = {
  patch: {
    tags: tagsPatchBuilding_groups_groupIdBuildings,
    params: paramsPatchBuilding_groups_groupIdBuildings,
    body: bodyPatchBuilding_groups_groupIdBuildings,
    response: responsePatchBuilding_groups_groupIdBuildings
  }
}
export interface Building_groups_groupIdBuildings extends BaseRouteType {
  patch: IPatchBuilding_groups_groupIdBuildings
}